'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class;

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _basket = require('redux/actions/basket');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ShareBasket: {
        displayName: 'ShareBasket'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Basket/ShareBasket.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ShareBasket = _wrapComponent('ShareBasket')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var code = params.code || '';

        return dispatch((0, _extends3.default)({}, (0, _basket.getSharedBasket)(code)));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang
    };
}), _dec(_class = _dec2(_class = function (_Component) {
    (0, _inherits3.default)(ShareBasket, _Component);

    function ShareBasket(props) {
        (0, _classCallCheck3.default)(this, ShareBasket);
        return (0, _possibleConstructorReturn3.default)(this, (ShareBasket.__proto__ || (0, _getPrototypeOf2.default)(ShareBasket)).call(this, props));
    }

    (0, _createClass3.default)(ShareBasket, [{
        key: 'render',
        value: function render() {
            var helmetTitle = this.props.lang['store.helmet.cart'];

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
                _react3.default.createElement(_components2.Basket, { before: _react3.default.createElement(_components2.OrderSteps, { step: '1' }) })
            );
        }
    }]);
    return ShareBasket;
}(_react2.Component)) || _class) || _class));

exports.default = ShareBasket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Basket/ShareBasket.jsx
// module id = 1801
// module chunks = 0